import { Injectable, OnDestroy } from '@angular/core';
import { UpaData } from './model/upa-data';
import { WindowRef } from '../window.service';
import { CookieService } from 'ngx-cookie-service';
import { Store, select } from '@ngrx/store';
import { AppState } from 'src/app/interfaces/app-state';
import { takeWhile, filter } from 'rxjs/operators';
import * as fromReview from './../../store/reducers/city.reducer';
import { FLOW } from './model/upa-constants';

@Injectable()
export class UpaService implements OnDestroy {
  componentActive = true;
  private upaDataTracker: any;
  private ip: string;
  private socialId: string;

  constructor(private window: WindowRef, private cookieService: CookieService, private store: Store<AppState>) {
    this.upaDataTracker = window.nativeWindow['UpaDataTracker'];
    this.store
      .pipe(
        select(fromReview.getCityForm),
        takeWhile(() => this.componentActive),
        filter(val => val !== undefined && val !== null)
      )
      .subscribe(cityForm => {
        this.ip = cityForm.ip;
        this.socialId = cityForm.socialId;
      });
  }

  trackUpa(data: UpaData) {
    if (!this.upaDataTracker) return;

    const dataToSend: any = {
      pr: data.pr,
      fl: data.fl,
      stage_number: data.stage_number,
      stage: data.stage,
      selection: data.selection,
      xClient: 'reviews-front',
      tcli: 'suppliers-it',
      userid: this.cookieService.get('trackerid') ? this.cookieService.get('trackerid') : '',
      cc: this.window.nativeWindow['country'],
      ch: this.checkIsMobile(),
      despegarid: this.socialId,
      ip: this.ip ? this.ip : '',
      ref: document.referrer ? document.referrer : 'no-ref',
      url: document.location.href ? document.location.href : '',
      userAgent: navigator.userAgent ? navigator.userAgent : '',
      loggedLevel: this.checkIfLogged()
    };

    if (data.fl === FLOW.CITIES_E) {
      dataToSend.eventtype = data.eventtype;
      dataToSend.event = data.event;
    }

    //Fix for case when country code is 'international', use 'US' instead
    if (dataToSend.cc === 'INTL') dataToSend.cc = 'US';

    this.upaDataTracker.send(dataToSend);
  }

  checkIsMobile() {
    if (
      /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
      /Mobile/i.test(navigator.userAgent)
    ) {
      return 'site-smartphone';
    } else {
      if (
        /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
        /Mobile/i.test(navigator.userAgent) === false
      ) {
        return 'site-tablet';
      } else {
        return 'site';
      }
    }
  }

  checkIfLogged() {
    if (this.cookieService.get('dss') && this.cookieService.get('dss2')) {
      return 'level2';
    } else {
      if (this.cookieService.get('dss')) {
        return 'level1';
      } else {
        return 'level0';
      }
    }
  }

  ngOnDestroy() {
    this.componentActive = false;
  }
}
